import React from 'react';
import moment from 'moment';
import { isEmpty } from 'lodash';
import { makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import config from '@/configs/config';
import ProgressBackdrop from '../../../preorder/components/ProgressBackdrop';
import Item from './Item';

const useRedeemCodeStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1.5),
  },
  voucherList: {
    marginTop: theme.spacing(2),

    '& > *+*': {
      marginTop: theme.spacing(1.5),
    },
  },
  divider: {
    borderTop: '1px solid black',
    margin: theme.spacing(2, 0),
  },
  title: {
    fontWeight: 'bold',

    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  redeemCodeContainer: {
    background: '#ebebeb',
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    fontSize: 12,
    padding: theme.spacing(1),

    marginTop: theme.spacing(3),
  },
  redeemCode: {
    background: 'white',
    borderRadius: 8,
    color: '#b50505',
    fontSize: 24,
    height: 38,
    padding: theme.spacing(0.5, 2),
    textAlign: 'center',
    flexShrink: 0,
  },
  codeContainer: {
    alignItems: 'center',
    display: 'flex',
    fontSize: 16,
    fontWeight: 'bold',
    flexShrink: 0,
  },
  expirationTime: {
    fontSize: 12,
    fontWeight: 'normal',
    color: '#6b6b6b',
    margin: theme.spacing(1, 0),
  },
  list: {
    margin: theme.spacing(1, 0),
    paddingInlineStart: '16px',
  },
  emptyText: {
    color: '#2f2f2f',
    fontSize: 20,
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
}));

const useLoadingItemStyle = makeStyles({
  root: {
    display: 'flex',
    position: 'relative',
    width: '100%',
  },
  content: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
  },
});

const LoadingItem = () => {
  const classes = useLoadingItemStyle();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Skeleton variant="text" />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
      </div>
    </div>
  );
};

export default ({
  expireTime,
  isInited,
  isLoading,
  redeemCode,
  vouchers,
}) => {
  const classes = useRedeemCodeStyle();
  const expireTimeString = expireTime ? moment(expireTime).utcOffset(8).format('YYYY/MM/DD HH:mm:ss') : '-------------------------';

  return (
    <div className={classes.root}>
      <ProgressBackdrop isShow={isLoading} />
      <div className={classes.title}>我的取貨碼</div>
      <div className={classes.redeemCodeContainer}>
        <div className={classes.codeContainer}>
          <div style={{ flexShrink: 0 }}>動態取貨碼：</div>
          <div className={classes.redeemCode}>{redeemCode || '- - - - - -'}</div>
        </div>
        <div className={classes.expirationTime}>{`本組取貨碼將於 ${expireTimeString} 到期`}</div>
        <div>請注意：</div>
        <ol className={classes.list}>
          <li>取貨碼可取所有您已預訂且於預計領取時段之商品。</li>
          <li>如取貨碼到期，請重新整理頁面以取得最新一組動態取貨碼。</li>
          <li>如需他人代領您預訂的商品，請務必輸入屬於您的最新一組動態取貨碼。</li>
        </ol>
      </div>
      <hr className={classes.divider} />
      <div className={classes.title}>已預定商品清單</div>
      <div className={classes.redeemCodeContainer}>
        <div>請注意：</div>
        <ol className={classes.list}>
          <li>
            可領取時段僅供參考，請以
            {config.BrandNameTW}
            官方 LINE 帳號的到貨通知為主。
          </li>
        </ol>
      </div>
      <div className={classes.voucherList}>
        {isInited && isEmpty(vouchers) && (
          <div className={classes.emptyText}>您沒有任何已預定商品</div>
        )}
        {(isLoading && !isInited) && (
          [1, 2].map((key) => (
            <LoadingItem key={key} />
          ))
        )}
        {vouchers.map((voucher) => {
          const { id } = voucher || {};

          return (
            <Item data={voucher} key={id} />
          );
        })}
      </div>
    </div>
  );
};
